import React from 'react';
import RateSeparatorPill from './RateSeparatorPill';
import RateSeparatorBar from './RateSeparatorBar';
import { RATE_SEPARATOR_DESIGNS } from '../constants/bookingConst';

/**
 * A rate separator's label in whichever design is selected (Config -> Sports
 * & Courts -> Hourly rates): Design 1 the centred pill, Design 2 the
 * full-width bar. One place to switch, used by both grids and every preview.
 *
 * @param {object} props
 * @param {string} props.design - a RATE_SEPARATOR_DESIGNS value
 * @param {string} [props.name]
 * @param {string} [props.icon]
 * @param {string} [props.color]
 * @param {string} [props.price]
 * @param {string} [props.hours]
 * @returns {JSX.Element}
 */
function RateSeparatorLabel({ design, ...labelProps }) {
  return design === RATE_SEPARATOR_DESIGNS.PILL
    ? <RateSeparatorPill {...labelProps} />
    : <RateSeparatorBar {...labelProps} />;
}

export default RateSeparatorLabel;
